import { Icon } from "@iconify/react";
import Logo from "../asset/images/Area-56-logo.png";
const Area56LoaderPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      {/* Logo and Restaurant Name */}

      {/* Plate Animation */}
      <div className="relative my-8">
        {/* Outer Ring */}
        <div
          className="absolute -inset-3 border-2 border-secondary rounded-full animate-spin"
          style={{ animationDuration: "8s" }}
        ></div>

        {/* Plate */}
        <div className="w-28 h-28 bg-primary rounded-full flex items-center justify-center shadow-lg shadow-secondary/30">
          {/* Food Item */}
          {/* <div className="w-14 h-7 bg-secondary rounded-t-xl relative"> */}
          {/* Food Details */}
          <div className="text-center mb-8 animate-pulse mt-2">
            <img src={Logo} alt="AREA 56 Logo" className="w-14" />
          </div>
          {/* <div className="absolute w-2 h-2 bg-red-500 rounded-full top-1 left-3"></div>
            <div className="absolute w-2 h-2 bg-green-500 rounded-full top-1 right-3"></div> */}
          {/* </div> */}
        </div>

        {/* Utensils */}
        <div
          className="absolute inset-4 animate-spin"
          style={{ animationDuration: "12s", animationDirection: "reverse" }}
        >
          <div className="absolute top-12 flex items-center justify-center gap-2 my-4">
            <Icon
              icon="mdi:silverware-fork"
              className="text-5xl text-secondary animate-[rotate_3s_ease-in-out_infinite]"
              style={{
                animation: "forkRotate 3s ease-in-out infinite",
              }}
            />
            <Icon
              icon="mdi:silverware-knife"
              className="text-5xl text-secondary animate-[rotate_3s_ease-in-out_infinite] scale-y-[1] scale-x-[-1]"
              style={{
                animation: "knifeRotate 3s ease-in-out infinite",
              }}
            />
          </div>
        </div>
      </div>

      {/* Loading Text */}
      <div className="mt-6 text-xl font-medium">
        <span className="text-secondary">Loading</span>
      </div>

      {/* Loading Dots */}
      <div className="flex space-x-2 mt-4">
        <div
          className="w-2 h-2 rounded-full bg-secondary animate-bounce"
          style={{ animationDelay: "0ms" }}
        ></div>
        <div
          className="w-2 h-2 rounded-full bg-secondary animate-bounce"
          style={{ animationDelay: "200ms" }}
        ></div>
        <div
          className="w-2 h-2 rounded-full bg-secondary animate-bounce"
          style={{ animationDelay: "400ms" }}
        ></div>
      </div>
    </div>
  );
};

export default Area56LoaderPage;
